export default {
  // beforeCreate() {
  //   // 强制设置国际化对象
  //   this._i18n =
  //     this.$root?.$i18n ||
  //     this.$options?.parent?.$i18n ||
  //     document.querySelector("#app").__vue__?.$i18n;
  // },
  created() {
    // 如果项目注入了自己的国际化对象
    if (this.$i18n) {
      this.t = (...args) => {
        args[0] = `platform.${args[0]}`;
        return this.$t.apply(this, args);
      }
    }
    // 否则这里使用element内置的
    else {
      this.t = ELEMENT.Calendar.mixins[0].methods.t;
    }
  },
  // methods: {
  //   // 解决在切换国际化时，element组件不生效问题
  //   t() {
  //     const args = Array.prototype.slice.call(arguments);
  //     args[0] = `platform.${args[0]}`;
  //     return this.$t.apply(this, args);
  //   },
  // },
};
